import axios from "axios";
import { BASE_URL } from "../config";

const authHeaders = () => {
  const token =
    localStorage.getItem("authentication/token") ||
    localStorage.getItem("auth_token") ||
    localStorage.getItem("token") ||
    "";

  return token ? { Authorization: `Bearer ${token}` } : {};
};

const providerPaymentUrl = (path) => `${BASE_URL}/provider-payment/bank-validation${path}`;

export const checkProviderBankValidationApprover = () =>
  axios.get(providerPaymentUrl("/approver"), { headers: authHeaders() });

export const getPendingBankDetailUpdates = () =>
  axios.get(providerPaymentUrl("/pending"), { headers: authHeaders() });

export const getCompletedBankDetailUpdates = () =>
  axios.get(providerPaymentUrl("/completed"), { headers: authHeaders() });

export const getBankDetailUpdateHistory = (params) =>
  axios.get(providerPaymentUrl("/history"), { params, headers: authHeaders() });

export const regenerateBankValidationFileUrl = (payload) =>
  axios.post(providerPaymentUrl("/regenerate-url"), payload, { headers: authHeaders() });

export const approveBankDetailUpdate = (requestId) =>
  axios.post(providerPaymentUrl(`/${requestId}/approve`), {}, { headers: authHeaders() });

export const disapproveBankDetailUpdate = (requestId, reason) =>
  axios.post(providerPaymentUrl(`/${requestId}/disapprove`), { reason }, { headers: authHeaders() });
